<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup></script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background: #0d0015;
  min-height: 100vh;
  color: white;
}

/* Navbar */
.axion-navbar {
  background: linear-gradient(90deg, #1a001f, #2b0033);
  box-shadow: 0 0 15px rgba(255, 0, 204, 0.3);
}

.nav-link {
  color: #ccc !important;
  transition: 0.3s;
}

.nav-link:hover {
  color: #ff00cc !important;
}

.router-link-exact-active {
  color: #ff00cc !important;
  font-weight: bold;
}

.glow-text {
  text-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
}

.text-pink {
  color: #ff00cc;
}

/* Modal */
.axion-modal {
  background: #1a001f;
  border: 1px solid #ff00cc;
  color: white;
}

.btn-pink {
  background: #ff00cc;
  border: none;
  color: white;
  transition: 0.3s;
}

.btn-pink:hover {
  background: #e600b8;
  box-shadow: 0 0 10px #ff00cc;
}
</style>
